import { InterfaceInstanceFunctionParams } from '@/backend/access/interfaceInstanceFunction/types';

export class InterfaceInstanceFunction {
  id: string;
  functionalInterfaceId: string;
  functionTitle: string;
  functionDescription: string;
  createdAt?: string;
  updatedAt?: string;
  orgId: string;

  constructor(params: InterfaceInstanceFunctionParams) {
    this.id = params.id;
    this.functionalInterfaceId = params.functionalInterfaceId;
    this.functionTitle = params.functionTitle;
    this.functionDescription = params.functionDescription || '';
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.orgId = params.orgId;
  }

  toData() {
    return {
      id: this.id,
      functionalInterfaceId: this.functionalInterfaceId,
      functionTitle: this.functionTitle,
      functionDescription: this.functionDescription,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      orgId: this.orgId,
    };
  }
}
